import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from '../../vendors/gsap/SplitText';

import lottie from 'lottie-web';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Newsletter2025Q1 {
  static _instance = null;

  static create(data) {
    if (Newsletter2025Q1._instance === null) {
      Newsletter2025Q1._instance = new Newsletter2025Q1(data);
    }
  }

  static destroy() {
    if (Newsletter2025Q1._instance) {
      Newsletter2025Q1._instance.beforeDestroy();
      Newsletter2025Q1._instance = null;
    }
  }

  constructor(data) {
    this.container = data;
    this.scroller = window.scroller
    this.isMobile = this.scroller.scroll.isMobile;

    this.initIllustration();
    this.initNavigation();
    this.setupScrollTrigger();
    this.setupMenuColorScrollTrigger();
    this.scrollAnimations();
  }

  initIllustration() {
    this.illustration = {
      element: document.querySelector('.nl-hero .illustration'),
      animation: null,
    };

    this.illustration.mediaTypeOnMobiles = this.illustration.element.dataset.mediaTypeMobiles;

    if(!this.isMobile || this.illustration.mediaTypeOnMobiles === 'lottie') {
      this.illustration.element.classList.add('is-animated');
      this.illustration.animation = lottie.loadAnimation({
        container: this.illustration.element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        rendererSettings: {
          preserveAspectRatio:'xMidYMid meet'
        },
        path: `${window.theme_assets_url}/lottie/newsletter2025q1/hero2.json`,
      })

      this.illustration.animation.addEventListener('DOMLoaded', () => {
        this.illustration.element.classList.add('is-visible');
      })
    } else {
      this.illustration.element.classList.add('is-visible');
    }
  }

  animationHero() {
    const introCategory = document.querySelector('#introduction .category-title');
    const introHeading = document.querySelector('#introduction h1');
    const introText = document.querySelector('#introduction .txt');

    if (introHeading) {
      const splitHeading = new SplitText(introHeading, {
        type: 'lines',
        linesClass: 'js-line'
      });

      if(introCategory) {
        gsap.set(introCategory, {
          opacity: 0,
        });
      }

      if(introText) {
        gsap.set(introText, {
          opacity: 0,
          y: 30,
        });
      }

      splitHeading.lines.forEach(line => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('js-line-wrapper');
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);

        gsap.set(line, {
          yPercent: 100,
        });
      });
    }

    const introTimeline = gsap.timeline();


    if(introHeading) {
      introTimeline.to('#introduction h1 .js-line', {
        yPercent: 0,
        stagger: 0.2,
        ease: 'power1.out',
        duration: .6,
      }, .5);
    }

    if(introCategory) {
      introTimeline.to(introCategory, {
        opacity: 1,
        duration: .6,
      }, .7);
    }

    if(introText) {
      introTimeline.to(introText, {
        opacity: 1,
        y: 0,
      }, .9);
    }

    gsap.to('.txt-wrap .h2', {
      scrollTrigger: {
        trigger: '.nl-hero',
        start: 'top top',
        end: '50% top',
        scroller: '[data-scroll-container]',
        scrub: true,
      },
      scale: 0.7,
      transformOrigin: 'left bottom',
      ease: 'power1.out',
    });
  }

  animationOnAi() {
    const story = document.querySelector('#on-ai--story');
    const glow = document.querySelector('.nl-powered-ai .heading-glow');
    const glowBackground = document.querySelector('.nl-powered-ai .heading-glow-before');


    if(glowBackground && !this.isMobile) {
      const glowTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: glow,
          start: 'top 80%',
          end: 'bottom 65%',
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
        .fromTo(glowBackground, {
          opacity: 0,
          }, {
          opacity: 1,
        })
    }

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.nl-powered-ai',
        start: 'top 40%',
        end: () => this.isMobile ? 'top 10%' : 'top -50%',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    if(story) {
      timeline.fromTo(story, {
        opacity: 0,
        y: "+=50",
        scale: 1.4,
      },{
        opacity: 1,
        y: 0,
        scale: 1,
        duration: .3,
        transformOrigin: 'center top',
        ease: 'none',
      })
    }


    if(story && ! this.isMobile) {
      timeline.to(story, {
        scale: 0.6,
        ease: 'none',
      }, "+=.5")
    }
  }

  animationPodcasts() {
    const podcastsContainer = document.querySelector('.nl-podcast')
    const podcastsHeading = podcastsContainer.querySelector('.heading h2')

    if(podcastsContainer && podcastsHeading) {
      gsap.fromTo(podcastsHeading, {
        scale: 3,
        y: () => {
          return `-${window.innerHeight / 2}`;
        },
      },{
        scale: 1,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: podcastsContainer,
          start: 'top bottom',
          end: "top 40%",
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: podcastsContainer,
          start: 'top top',
          end: "bottom bottom",
          pin: podcastsHeading,
          pinSpacing: false,
          pinType: this.isMobile ? 'fixed' : 'transform',
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      });

      // First animation
      tl.fromTo(podcastsHeading, {
        scale: 1,
        y: 0,
      },{
        scale: 1.8,
        y: () => {
          return `${window.innerHeight / 2 - podcastsHeading.offsetHeight}`;
        },
        opacity: 0,
        ease: 'none',
        duration: 1
      });

      tl.to({}, {duration: 1, ease: 'none'});
    }

    if(!this.isMobile) {
      ScrollTrigger.create({
        trigger: ".nl-podcast",
        start: "bottom bottom",
        end: () => {
          return `+=${window.innerHeight}`;
        },
        pin: '.nl-podcast--inner',
        pinSpacing: false,
        scroller: '[data-scroll-container]',
        pinType: this.isMobile ? 'fixed' : 'transform',
        invalidateOnRefresh: true,
      });
    }
  }

  animationStories() {
    const headingNews = document.querySelector('.nl-stories .heading')
    const titleNews1 = document.getElementById('news-title-1')
    const titleNews2 = document.getElementById('news-title-2')
    const titleNewsCenterEl = document.querySelector('.news-title-center')
    const titleNewsNotCenterEls = document.querySelectorAll('.news-title span:not(.news-title-center)')

    const fullStory = document.getElementById('full-story')

    if(titleNews1) {
      const titleNews1Span = titleNews1.querySelector('span');
      if (titleNews1Span) {
        gsap.set(titleNews1, {
          x: () => {
            const spanWidth = titleNews1Span.offsetWidth;
            const containerWidth = titleNews1.scrollWidth;
            return -1 * (containerWidth / 2 - spanWidth);
          }
        });
      }

      titleNewsNotCenterEls.forEach(el => {
        gsap.set(el, {
          opacity: 0,
        });
      })
    }

    if(headingNews) {
      gsap.set(headingNews, {
        scale: 3,
        y: 150,
        transformOrigin: 'center center',
      })
    }

    const newsTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.nl-stories',
        start: 'top 80%',
        end: 'top -40%',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    newsTimeline.to(headingNews, {
      scale: 1,
      y: 0,
      ease: 'none',
    })

    newsTimeline.to(titleNewsNotCenterEls, {
      opacity: 1,
      ease: 'none',
    }, "-=.15")

    if (titleNews1 && titleNews2) {
      newsTimeline.to(titleNews1, {
        x: '+=800',
        ease: 'none',
      }, "-=.2");

      newsTimeline.to(titleNews2, {
        x: '-=800',
        ease: 'none',
      }, "<");
    }

    if(fullStory) {
      const fullStoryFigure = fullStory.querySelector('.img')
      if(fullStoryFigure) {
        const fullStoryFigureBounds = fullStoryFigure.getBoundingClientRect()
        const maskProportion = {
          width: 0.9,
          height: 0.95
        }

        const maskWidth = fullStoryFigureBounds.width * maskProportion.width
        const maskHeight = fullStoryFigureBounds.width * .5625 * maskProportion.height

        const maskBounds = {
          top: 0,
          left: maskWidth / 2,
          right: maskWidth / 2,
          bottom: maskHeight
        }

        gsap.set(fullStoryFigure, {
          clipPath: `inset(${maskBounds.top}px ${maskBounds.right}px ${maskBounds.bottom}px ${maskBounds.left + 1}px)`,
          y: "-=100",
          opacity: 0
        })

        const fullStoryTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: fullStory,
            start: () => {
              return this.isMobile ? "top 87%" : "top 70%"
            },
            end: "+=30%",
            scrub: true,
            scroller: '[data-scroll-container]',
          },
        })
          .to(fullStoryFigure, {
            opacity: 1,
            ease: "power1.inOut",
          }, 0)
          .to(fullStoryFigure, {
          y: 0,
          clipPath: "inset(0px 0px 0px 0px)",
          ease: "none",
        }, 0);

      }
    }

    const slider = document.querySelector('.nl-stories-slider')

    const footer = document.querySelector('.nl-stories-footer')
    if(footer) {
      const footerTitle = footer.querySelector('h2')
      if(slider) {
        gsap.to(slider, {
          scale: .8,
          transformOrigin: 'center center',
          ease: 'none',
          scrollTrigger: {
            trigger: '.nl-stories',
            start: 'bottom 100%',
            end: 'bottom 80%',
            scrub: true,
            scroller: '[data-scroll-container]',
          }
        })
      }

      if(footerTitle) {
        gsap.set(footerTitle, {
          y: "-=100%",
        })
        gsap.to(footerTitle, {
          scale: 1,
          opacity: 1,
          transformOrigin: 'center center',
          y: "40%",
          ease: 'none',
          scrollTrigger: {
            trigger: '.nl-stories',
            start: 'bottom 120%',
            end: 'bottom 80%',
            scrub: true,
            scroller: '[data-scroll-container]',
            invalidateOnRefresh: true,
          }
        })

        gsap.to(footerTitle, {
          scale: .5,
          ease: 'none',
          transformOrigin: 'center center',
          scrollTrigger: {
            trigger: '.nl-stories',
            start: 'bottom 80%',
            end: () => {
              return `+=${window.innerHeight * .66}`;
            },
            scrub: true,
            scroller: '[data-scroll-container]',
            invalidateOnRefresh: true,
          }
        })
      }
    }
  }

  animationExploringMinds() {
    const exploringMindsHeading = document.querySelector('.nl-exploring-minds .heading h2 > b');
    const exploringMindsHeading2 = document.querySelector('.nl-exploring-minds .heading h2 > i');
    const exploringMindsHeading3 = document.querySelector('.nl-exploring-minds .heading h2 > span');

    let exploringMindsHeadingChars = null;
    let exploringMindsHeadingChars2 = null;
    let exploringMindsHeadingChars3 = null;

    if (exploringMindsHeading) {
      // Use SplitText to split the text into characters
      exploringMindsHeadingChars = new SplitText(exploringMindsHeading, {
        type: "chars",
        charsClass: "js-char"
      });

      // Wrap each character in a wrapper with class js-char-wrapper
      exploringMindsHeadingChars.chars.forEach(char => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('js-char-wrapper');
        char.parentNode.insertBefore(wrapper, char);
        wrapper.appendChild(char);
        gsap.set(char, {
          yPercent: 100,
        });
      });
    }

    if (exploringMindsHeading2) {
      exploringMindsHeadingChars2 = new SplitText(exploringMindsHeading2, {
        type: "lines",
        linesClass: "js-line"
      });

      exploringMindsHeadingChars2.lines.forEach(line => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('js-line-wrapper');
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
        gsap.set(line, {
          yPercent: -100,
        });
      });
    }

    if (exploringMindsHeading3) {
      exploringMindsHeadingChars3 = new SplitText(exploringMindsHeading3, {
        type: "lines",
        linesClass: "js-line"
      });

      exploringMindsHeadingChars3.lines.forEach(line => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('js-line-wrapper');
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
        gsap.set(line, {
          yPercent: -100,
        });
      });
    }

    const exploringMindsHeadingTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.nl-exploring-minds',
        start: 'top 70%',
        end: 'top 30%',
        scrub: true,
        scroller: '[data-scroll-container]',
      }
    })

    if (exploringMindsHeadingChars) {
      exploringMindsHeadingTimeline.to(exploringMindsHeadingChars.chars, {
        yPercent: 0,
        ease: 'none',
        stagger: {
          each: 0.2,
        }
      })
    }

    if (exploringMindsHeadingChars2) {
      exploringMindsHeadingTimeline.to(exploringMindsHeadingChars2.lines, {
        yPercent: 0,
        ease: 'none',
      }, "+=.5")
    }

    if (exploringMindsHeadingChars3) {
      exploringMindsHeadingTimeline.to(exploringMindsHeadingChars3.lines, {
        yPercent: 0,
        ease: 'none',
      })
    }

    if(this.isMobile) {
      gsap.fromTo('.nl-exploring-minds .heading h2', {
        scale: 1.3,
      }, {
        scale: 1,
        transformOrigin: 'right top',
        scrollTrigger: {
          trigger: '.nl-exploring-minds',
          start: 'top 55%',
          end: 'top 20%',
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
    } else {
      gsap.to('.nl-exploring-minds .heading h2', {
        scale: 0.7,
        transformOrigin: 'right top',
        scrollTrigger: {
          trigger: '.nl-exploring-minds',
          start: 'top 55%',
          end: 'top 20%',
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
    }

    const newsPosts = document.querySelectorAll('.nl-exploring-minds .nl-post-list .news-post-row');

    newsPosts.forEach((post, index) => {
      gsap.set(post, {
        opacity: 0,
        x: () => {
          return index % 2 === 0 ? 200 : -200;
        }
      });

      gsap.to(post, {
        opacity: 1,
        x: 0,
        scrollTrigger: {
          trigger: post,
          start: 'top 80%',
          end: 'top 45%',
          scrub: true,
          scroller: '[data-scroll-container]',
        }
      })
    })
  }

  scrollAnimations() {
    this.animationHero();
    this.animationOnAi();
    this.animationPodcasts();
    this.animationStories();
    this.animationExploringMinds();

    setTimeout(() => {
      ScrollTrigger.getAll().forEach((t) => t.refresh());
    }, 3000);
  }


  initNavigation() {
    this.header = document.getElementById('header');
    this.sections = Array.from(document.querySelectorAll('.section-content'));
    this.navLinks = Array.from(document.querySelectorAll('.nav-timeline .nav a'));
    this.colorMenuSections = Array.from(document.querySelectorAll('.color-menu'));

    this.navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);

        if (!targetSection) {
          console.error(`Target section not found: ${targetId}`);
          return;
        }

        // Get the offset for the target section
        let offset;

        if(this.isMobile) {
          offset = targetSection.dataset.scrollOffsetMobile || targetSection.dataset.scrollOffset || '0';
        } else {
          offset = targetSection.dataset.scrollOffset || '0';
        }
        console.log('offset', offset);
        if (offset.endsWith('%')) {
          const percentage = parseFloat(offset) / 100;
          offset = window.innerHeight * percentage;
        }

        // Scroll to the target section with the specified offset
        this.scroller.scrollTo(targetSection, {
          offset: parseInt(offset),
          duration: 1000,
          easing: [0.25, 0.00, 0.35, 1.00]
        });
      });
    });
  }

  setupScrollTrigger() {
    this.sections.forEach((section) => {
      try {
        ScrollTrigger.create({
          trigger: section,
          start: 'top 50%',
          end: 'bottom 50%',
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
          onEnter: () => this.updateActiveLink(section.id),
          onEnterBack: () => this.updateActiveLink(section.id),
        });
      } catch (error) {
        console.error(`Error creating ScrollTrigger for section ${section.id}:`, error);
      }
    });
  }

  setupMenuColorScrollTrigger() {
    this.colorMenuSections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 90px',
        end: 'bottom 90px',
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
        onEnter: () => this.updateMenuColor(section),
        onEnterBack: () => this.updateMenuColor(section),
      });
    });
  }

  updateActiveLink(sectionId) {
    const currentLink = document.querySelector(`.nav-timeline .nav a[href="#${sectionId}"]`);

    if (!currentLink) {
      console.error(`Link not found for id: ${sectionId}`);
      return;
    }

    // Remove active class from all links
    this.navLinks.forEach(link => link.parentElement.classList.remove('active'));

    // Add active class to current link
    currentLink.parentElement.classList.add('active');
  }

  updateMenuColor(section) {
    if (this.header) {
      this.header.classList.remove('dark-menu', 'light-menu');
      if (section.classList.contains('dark-menu')) {
        this.header.classList.add('dark-menu');
      } else if (section.classList.contains('light-menu')) {
        this.header.classList.add('light-menu');
      }
    } else {
      console.error('Header element not found');
    }
  }

  beforeDestroy() {
    ScrollTrigger.getAll().forEach((t) => t.kill());
  }
}
